import { useState, useEffect } from 'react';
import { HeroBannerEditableData } from '../types';

export const useHeroBannerData = (initialData: HeroBannerEditableData | null = null, delay = 100) => {
  const [heroBannerEditableData, setHeroBannerEditableData] = useState<HeroBannerEditableData | null>(initialData);
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  useEffect(() => {
    if (initialData) {
      // Petit délai pour éviter le flash
      const timer = setTimeout(() => {
        setHeroBannerEditableData(initialData);
        setIsDataLoaded(true);
      }, delay);
      
      return () => clearTimeout(timer);
    } else {
      setIsDataLoaded(false);
      setHeroBannerEditableData(null);
    }
  }, [initialData, delay]);

  return {
    heroBannerEditableData,
    setHeroBannerEditableData,
    isDataLoaded
  };
}; 